import axios from "axios";
import { getApiConfig } from "../../apiConfig";
import { GetIncidentActivityTypesService } from "../../incidentService";


// const incidentActivityTypes = {
//   'Comentario del informante': '05f0cd43-be49-4d9b-91aa-1488ee974f81',
//   'Acta de reunión': '23ead1bd-ed43-4aeb-8ee0-e45bcedbf5f8',
//   'Comentario del responsable': '4c1c0dc2-42c8-4fa8-9b46-da8c01eac44a',
//   'Petición de reunión': '66d6ab54-77d4-499c-a2af-52d7df6bdb0f',
//   'Creación caso': '98b3f360-8a15-49a4-97cc-856024bacf8f',
//   'Cambio de responsable': '9c43c2f2-e823-4137-b706-31c8c933d20c',
//   'Vista': 'd86adaaa-6811-4b8f-acc0-d91dda52c930',
//   'Propuesta de resolución': 'e6ca1b11-97ff-4dab-bde2-ae5c619cdb17',
//   'Propuesta de reunión': 'f9c8747b-1143-4359-ad3e-a97336f5938e',
//   'Ampliación de plazo': '41a99d59-bd4e-4468-b744-5ed17f1f9f34',
//   'Cancelación': '685c9e48-dbb2-4303-b2cb-fca9cedc740a',
//   'Nota responsable': '679c0a2c-db0b-4564-8e56-4ec87d7477f7',
//   'Nota informante': '5f1ee1ad-a36c-4ea7-b591-cdbe347c2f8a',
// }


export async function PostIncidentActivity(object) {
  try {

    const activityTypes = await GetIncidentActivityTypesService();

    const incidentActivityTypes = {
      [activityTypes[4]]: '05f0cd43-be49-4d9b-91aa-1488ee974f81',
      [activityTypes[0]]: '23ead1bd-ed43-4aeb-8ee0-e45bcedbf5f8',
      [activityTypes[5]]: '4c1c0dc2-42c8-4fa8-9b46-da8c01eac44a',
      [activityTypes[9]]: '66d6ab54-77d4-499c-a2af-52d7df6bdb0f',
      [activityTypes[6]]: '98b3f360-8a15-49a4-97cc-856024bacf8f',
      [activityTypes[2]]: '9c43c2f2-e823-4137-b706-31c8c933d20c',
      [activityTypes[12]]: 'd86adaaa-6811-4b8f-acc0-d91dda52c930',
      [activityTypes[10]]: 'e6ca1b11-97ff-4dab-bde2-ae5c619cdb17',
      [activityTypes[11]]: 'f9c8747b-1143-4359-ad3e-a97336f5938e',
      [activityTypes[1]]: '41a99d59-bd4e-4468-b744-5ed17f1f9f34',
      [activityTypes[3]]: '685c9e48-dbb2-4303-b2cb-fca9cedc740a',
      [activityTypes[8]]: '679c0a2c-db0b-4564-8e56-4ec87d7477f7',
      [activityTypes[7]]: '5f1ee1ad-a36c-4ea7-b591-cdbe347c2f8a',
    }

    const incidentId = object.id;
    const incidentActivity = object.formData
    const activityType = object.activityType

    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}incidentActivity`;

    const file = incidentActivity.file
      ? {
        name: incidentActivity.file.fileName,
        mimeType: incidentActivity.file.mimeType,
        fileData: incidentActivity.file.base64Content,
        modifiedBy: "ea1e3cb5-8b39-4f3b-a938-b9070d9d9746",
      }
      : null;

    const incidentActivityTypeId = incidentActivityTypes[activityType];
    const incidentActivityPost = {
      incidentActivity: {
        incident: incidentId,
        title: object.title ? object.title : null,
        incidentActivityType: incidentActivityTypeId,
        description: incidentActivity.description,
        state: object.activityType === activityTypes[10] || object.activityType === activityTypes[11] ? '65e4955b-9814-400a-a3b8-0331f9d418dd' : null,
        location: incidentActivity.location ? incidentActivity.location : null,
        participants: incidentActivity.participants ? incidentActivity.participants : null,
        date: incidentActivity.date ? incidentActivity.date : null,
      },
      file: file,
    };
    const response = await axios.post(req, incidentActivityPost, apiConfig.HEADERS_CONFIG, {

    });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
